import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

// Keyed by Paragraph.uniqueLocalId (Word JS API 1.7+).
// Each entity: { id, text, style, styleBuiltIn, outlineLevel, type: "paragraph" | "tableCell" }
export const contentAdapter = createEntityAdapter();

export const INITIAL_STATE = {
  isListening: false,
  isOutlineSyncPending: false,
  isReanalyzing: false,
  isSaving: false,
  lastEditedAt: null,
  lastSavedAt: null,
  content: contentAdapter.getInitialState(),
  currentParagraphId: null,
  presenceInstanceId: null,
};

export const currentDocumentSlice = createSlice({
  name: "currentDocument",
  initialState: INITIAL_STATE,
  reducers: {
    documentEdited: (state, { payload }) => {
      state.lastEditedAt = payload ?? null;
    },
    documentSaved: (state, { payload }) => {
      state.lastSavedAt = payload ?? null;
    },
    resetCurrentDocument: () => INITIAL_STATE,
    setSaving: (state, { payload }) => {
      state.isSaving = Boolean(payload);
    },
    setListening: (state, { payload }) => {
      state.isListening = payload;
    },
    setOutlineSyncPending: (state, { payload }) => {
      state.isOutlineSyncPending = Boolean(payload);
    },
    setReanalyzing: (state, { payload }) => {
      state.isReanalyzing = payload;
    },
    setCurrentParagraphId: (state, { payload }) => {
      state.currentParagraphId = payload;
    },
    setPresenceInstanceId: (state, { payload }) => {
      state.presenceInstanceId = payload;
    },
    setContent: (state, { payload }) => {
      contentAdapter.setAll(state.content, payload);
    },
    applyContentDiff: (state, { payload: { toUpsert, toRemove, nextIds } }) => {
      if (toRemove.length) contentAdapter.removeMany(state.content, toRemove);
      if (toUpsert.length) contentAdapter.setMany(state.content, toUpsert);
      state.content.ids = nextIds;
    },
  },
});

export const {
  documentEdited,
  documentSaved,
  resetCurrentDocument,
  setCurrentParagraphId,
  setListening,
  setOutlineSyncPending,
  setPresenceInstanceId,
  setReanalyzing,
  setSaving,
  setContent,
  applyContentDiff,
} = currentDocumentSlice.actions;
